export enum PublishedSurveyStatus {
  OPEN = 'OPEN',
  EXPIRED = 'EXPIRED',
  ARCHIVED = 'ARCHIVED',
  COMPLETED = 'COMPLETED',
  SCHEDULED = 'SCHEDULED'
}
